import RegionList from '@framework/ui/Organisms/Filters/FiltersPanel/RegionList/RegionList';
import { useFiltersContext } from '@framework/ui/Organisms/Filters/FiltersContext';
import { CFR_ARTICLES } from '@/creditflowresearch/ui/components/creditFlow/articles/FiltersButton/constants';
import CheckboxWithTooltip from '@/creditflowresearch/ui/common/components/Sidebar/CheckboxWithTooltip';

interface ISidebarRegionListProps {
  filterName: string,
  parentFilterName: string,
}

const SidebarTwoLevelsList = (props: ISidebarRegionListProps) => {
  const { filters } = useFiltersContext();

  const stateProps = {
    filters: (CFR_ARTICLES in filters) ? filters[CFR_ARTICLES][props.filterName] : [],
  };

  // @ts-ignore
  return <RegionList { ...stateProps } { ...props } CheckboxComponent={ CheckboxWithTooltip } />;
};

export default SidebarTwoLevelsList;
